/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Meeting_Title_PlaceholderInputs */



/**
* | output |
* | --- |
* | "1:1 with Anne-Sophie" |
*
* @param {Manual_Meeting_Title_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const manual_meeting_title_placeholder = /** @type {((inputs?: Manual_Meeting_Title_PlaceholderInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Meeting_Title_PlaceholderInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("1:1 met Anne-Sophie")
	if (locale === "fr") return /** @type {LocalizedString} */ ("1:1 avec Anne-Sophie")
	return /** @type {LocalizedString} */ ("1:1 with Anne-Sophie")
});